export default __webpack_public_path__ + "static/media/Cloudxier-IKRIMAH-Profile-Designer.ef0cbc50.png";